import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import { FieldArray, Form, Formik } from "formik";
import FormikCheckbox from "components/form/formik-checkbox";
import Pagination from "components/pagination";

export default function AnswerThemingDialog({
    showAnswerThemingDialog,
    setShowAnswerThemingDialog,
    answerThemes,
    handleAnswerThemingSubmit,
    themesData,
    themesPage,
    onThemesPageChange,
    validationSchemaAnswerThemes,
}) {
    const handleClose = () => {
        setShowAnswerThemingDialog((showAnswerThemingDialog) => !showAnswerThemingDialog);
    };

    return (
        <Dialog
            open={showAnswerThemingDialog}
            handler={handleClose}
            className="dialog"
        >
            <DialogHeader className="dialog__header">
                Theme Answer
            </DialogHeader>
            <Formik
                initialValues={{
                    themes: answerThemes?.themes || [],
                }}
                onSubmit={handleAnswerThemingSubmit}
                validationSchema={validationSchemaAnswerThemes}
            >
                {({ isValid, dirty, values }) => (
                    <Form>
                        <DialogBody className="dialog__body">
                            <FieldArray name="themes">
                                {({ push, remove }) => (
                                    <div>
                                        {themesData?.data?.map((theme) => (
                                            <div
                                                className="border-b border-blue-gray-300"
                                                key={theme.id}
                                            >
                                                <div className=" align-bottom">
                                                    <FormikCheckbox
                                                        name="themes"
                                                        type="checkbox"
                                                        value={theme.id}
                                                        checked={values.themes.includes(
                                                            theme.id,
                                                        )}
                                                        onChange={(e) => {
                                                            if (
                                                                e.target.checked
                                                            ) {
                                                                push(theme.id);
                                                            } else {
                                                                const idx =
                                                                    values.themes.indexOf(
                                                                        theme.id,
                                                                    );
                                                                remove(idx);
                                                            }
                                                        }}
                                                    />
                                                    <span className="align-middle">
                                                        {theme.name || "N/A"}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FieldArray>
                        </DialogBody>
                        <DialogFooter className="dialog__footer">
                            <div className="mx-auto">
                                <Pagination
                                    currentPage={
                                        themesData?.pager?.current_page ||
                                        themesPage
                                    }
                                    lastPage={themesData?.pager?.last_page}
                                    onPageChange={onThemesPageChange}
                                />
                            </div>
                            <Button
                                type="button"
                                className="btn btn--secondary"
                                variant="filled"
                                size="lg"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                disabled={!(isValid && dirty)}
                                onClick={handleClose}
                                className="btn btn--primary ml-2"
                                variant="filled"
                                size="lg"
                            >
                                Save
                            </Button>
                        </DialogFooter>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
